import {createPopper} from "@popperjs/core";

jQuery(function ($) {
    const poppers = [];

    $('.has-tooltip').each(function() {
        const reference = $(this)[0];
        const tooltip = $(this).parent().children('.tooltip')[0];
        const popperInstance = createPopper(reference, tooltip, {
            placement: 'top',
        });

        poppers.push({
            reference: reference,
            tooltip: tooltip,
            popperInstance: popperInstance,
        });
    })

    function show(event) {
        $(event.data.tooltip).attr('data-show', true);
        event.data.popperInstance.update();
    }

    function hide(event) {
        $(event.data.tooltip).attr('data-show', null);
    }

    const showEvents = ['mouseenter', 'focus'];
    const hideEvents = ['mouseleave', 'blur'];

    showEvents.forEach((event) => {
        poppers.forEach(x => {
            $(x.reference).on(event, x, show);
        });
    });

    hideEvents.forEach((event) => {
        poppers.forEach(x => {
            $(x.reference).on(event, x, hide);
        });
    });
});